class LocalizationForm extends HTMLElement {
  constructor() {
    super()
    this.elements = {
      modalTrigger: document.querySelector('[data-localization-form-modal-trigger]'),
      modalClose: document.querySelector('[data-localization-form-close]'),
      modal: document.querySelector('[data-localization-form-modal')
    }

    this.elements.modalTrigger.addEventListener('click', this.openModal.bind(this))
    this.elements.modalClose.addEventListener('click', this.closeModal.bind(this))
    this.elements.modal.addEventListener('click', this.detectOutsideClick.bind(this))
  }

  openModal() {
    this.elements.modal.classList.add('open')
    this.elements.modalTrigger.setAttribute('aria-expanded', 'true')
    document.addEventListener('keyup', this.handleEsc.bind(this))
    const select = this.querySelector('.select_wrapper')
    select.tabIndex = 0

    // Move focus to first focusable element in the dialog
    const modalBody = this.elements.modal.querySelector('.localization-form__modal-body')
    if (modalBody) {
      const firstFocusable = modalBody.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      if (firstFocusable) {
        setTimeout(() => {
          firstFocusable.focus()
        }, 100)
      }
    }
  }

  closeModal() {
    this.elements.modal.classList.remove('open')
    this.elements.modalTrigger.setAttribute('aria-expanded', 'false')
    document.removeEventListener('keyup', this.handleEsc.bind(this))
    const select = this.querySelector('.select_wrapper')
    select.tabIndex = -1
  }

  detectOutsideClick(e) {
    const isOutside = !e.target.closest('.localization-form__modal-body')
    isOutside && this.closeModal()
  }

  handleEsc(e) {
    if (e.key === 'Escape') {
      this.closeModal()
    }
  }
}

customElements.define('localization-form', LocalizationForm)
